import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class SessionService {
  url: string;
  sessionItem: any = JSON.parse(localStorage.getItem(environment.auth.key));
  tokenKey: any = environment.auth.key;
  userData: any = {
    idUsuario:null,
    login:null,
    nombre:null,
    primerApellido:null,
    segundoApellido:null,
    telVigente:null,
    curp:null,
    fechaNacimiento:null,
    sexo:null,
    idEstadoNacimiento:null,
    estadoNacimiento:null,
    idRolUsuario:null,
    descripcionRol:null
  }

  constructor (
    private http: HttpClient
  ) {
    this.url = environment.api.base_endpoint;
  }

  async getSession() {
    try {
      // CASE: User lands on any page, onInit calls get session to validate if user has an active session
      // I: Checks if user has localStorage of session information
      if (this.sessionItem) {
        // II: Send code to WS to get status of session
        let hasSession = await this.http.get(`${this.url}validate?code=${this.sessionItem.accessToken}`).toPromise();

        if (hasSession) {
          // III: WS returns 200, status = TRUE
          return true;
        } else {
          // IV: WS returns 401, session on localStorage should be deleted, status = FALSE
          localStorage.removeItem('OauthIdentityServiceProvider.CDMX.LastUser');

          return false;
        }
      } else {
        // V: There is no localStorage (brand new session)

        return false;
      }
    } catch (err) {
      // VI: WS fails unexpectedly, falsify session
      // Ask retry ?

      return false;
    }
  }

  async keepAliveSession() {
    // TODO run in background to refresh if session is still alive or handle re-login
  }


  async login(authCode) {
    try {
      // Send token to backend to do hand shaking and authorization
        const res = await this.http.get(`${this.url}token?code=${authCode.code}`).toPromise();
        // If promise is successful set authorization to app localStorage
        localStorage.setItem(environment.auth.key, JSON.stringify(res));

        return res;
    } catch (err) {
      // console.log('err ? ', err)

      return err;
    }
  }

  async getTramitesPublicados () {
    try {
      // const res = await this.http.get(`${this.url}tramites`).toPromise();
    } catch (err) {
      // console.log('err ', err);
    }
  }
}
